module.exports = [{
      plugin: require('/Users/atiff/Dropbox/dev/fsc/components/fsc-blog/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/atiff/Dropbox/dev/fsc/components/fsc-blog/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":590},
    },{
      plugin: require('/Users/atiff/Dropbox/dev/fsc/components/fsc-blog/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
